module.exports = __webpack_public_path__ + "static/media/Bosch Kessel Konfigurator ISH 2015.19b43d05.mp4";